import { useEffect, useRef, useState } from "react";

/**
 * Fixed-pixel chart viewport. Width is measured with hysteresis so a
 * ResponsiveContainer / scrollbar loop cannot retick every frame.
 */
export function FixedChart({ height, children }) {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const apply = (raw) => {
      const next = Math.floor(raw);
      if (next < 1) return;
      setWidth((prev) => (Math.abs(prev - next) < 4 ? prev : next));
    };
    apply(el.clientWidth);
    if (typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver((entries) => {
      apply(entries[0]?.contentRect?.width || 0);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      style={{
        width: "100%",
        height,
        minHeight: height,
        maxHeight: height,
        overflow: "hidden",
        position: "relative",
      }}
      data-testid="fixed-chart"
    >
      {width > 0 ? children(width) : null}
    </div>
  );
}
